import type { Direction, Position } from '@/features/letterParty/types';

type VibeTier = 'cold' | 'warm' | 'hot' | 'hype';

const SAFE_AREA_WIDTH = 5;
const SAFE_AREA_HEIGHT = 5;
const OPPOSITE_DIRECTIONS: Record<Direction, Direction> = {
	UP: 'DOWN',
	DOWN: 'UP',
	LEFT: 'RIGHT',
	RIGHT: 'LEFT',
};

export function getVibeTier(level: number): VibeTier {
	if (level >= 80) return 'hype';
	if (level >= 50) return 'hot';
	if (level >= 25) return 'warm';
	return 'cold';
}

export function isWithinSafeArea({ x, y }: Position): boolean {
	return x >= 0 && x < SAFE_AREA_WIDTH && y >= 0 && y < SAFE_AREA_HEIGHT;
}

export function getOppositeDirection(direction: Direction): Direction {
	return OPPOSITE_DIRECTIONS[direction];
}

export function isValidDirectionChange(currentDirection: Direction, newDirection: Direction): boolean {
	return getOppositeDirection(currentDirection) !== newDirection;
}

export function cloneAnimationData<T>(animationData: T): T {
	if (typeof structuredClone === 'function') {
		return structuredClone(animationData);
	}

	return JSON.parse(JSON.stringify(animationData)) as T;
}

export function getInitialSnakePositions(): Position[] {
	const startY = 1; // Start from second row (0-indexed)
	const headX = Math.min(SAFE_AREA_WIDTH - 1, 2);

	return [
		{ x: headX, y: startY },
		{ x: headX - 1, y: startY },
		{ x: Math.max(0, headX - 2), y: startY },
	];
}
